import { autorun, makeAutoObservable, runInAction } from "mobx";
class AndOrSelectDropdownStore {
    rootStore;
    fieldKey;
    defaultOption = { };
    options = [];
    selectedValues = [];
    operatorOptions = [
        { label: "OR", value: "OR" },
        { label: "AND", value: "AND" },
    ];
    operator = [{ label: "OR", value: "OR" }];
    constructor(rootStore, fieldKey) {
        this.rootStore = rootStore;
        this.fieldKey = fieldKey;
        makeAutoObservable(this);
        autorun(() => {
            // Debugging or logging state changes if needed
        });
    }
    setOptions(newOptions = []) {
        runInAction(() => {
            // Add "Select All" option only if multiselect is enabled
            this.options = [...newOptions];
        });
    }
    getOptions() {
        return this.options;
    }
    getSelectedValues() {
        return this.selectedValues;
    }
    setSelectedValues(values) {
        this.selectedValues = values || [];
    }
    handleSelectChange({ selected }) {
        if (!Array.isArray(selected)) {
            this.selectedValues = selected ? [selected] : [];
            return;
        }
        const hasSelectAll = selected.some((s) => s.value === this.defaultOption?.value);
        if (hasSelectAll) {
            const allOptions = this.options.filter(opt => opt.value !== this.defaultOption?.value);
            this.selectedValues = allOptions;
        } else {
            this.selectedValues = selected;
        }
    }
    setOperator(operator) {
        // Accept either a single operator object or array
        this.operator = Array.isArray(operator) ? operator : [operator];
    }

    getCurrentOperator() {
        // Return the first operator in the array (or default if empty)
        return this.operator[0] || this.operatorOptions[0];
    }

    clearMe() {
        runInAction(() => {
            this.selectedValues = [];
            this.operator = [{ label: "OR", value: "OR" }];
        })
    }
}
export default AndOrSelectDropdownStore;
